var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_done"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 360 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7072 7.70712L9.00008 19.4142L3.29297 13.7071L4.70718 12.2929L9.00008 16.5858L19.293 6.29291L20.7072 7.70712Z",
    fill: "#237BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionDone);
export default __webpack_public_path__ + "static/media/ic_action_done.8de08946c00116bc713e46c1f21f4712.svg";
export { ForwardRef as ReactComponent };